"use client"; // Error boundaries must be Client Components

import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import PageLayout from "components/PageLayout/PageLayout";
import { useEffect } from "react";

export default function Error({ error, reset }) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);
  return (
    <PageLayout front>
      <ErrorMessage
        code={500}
        message="Er is een fout opgetreden. Probeer het nog eens of neem contact met ons op."
        reset={reset}
      />
    </PageLayout>
  );
}
